import styles from './LeaveMessage.module.css';
import { useEffect, useState } from 'react';

interface LeaveMessageProps {
  icon: string;
  displayName: string;
}

function LeaveMessage({ icon, displayName }: LeaveMessageProps): JSX.Element {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isVisible, setIsVisible] = useState(false);
  
  // Check for mobile view on resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Animation effects sequence
  useEffect(() => {
    // Initial delay before showing message
    const messageTimer = setTimeout(() => {
      setIsVisible(true);
    }, 300);
    
    return () => clearTimeout(messageTimer);
  }, []);

  // Determine the appropriate CSS classes based on message type and state
  const containerClass = `${styles.leaveMessage} ${isVisible ? styles.visible : ''}`;
  
  return (
    <div className={containerClass}>
      <div className={styles.narratorContent}>
        <div className={styles.leaveMessageIconContainer}>
          <img src={icon} alt={displayName} className={styles.leaveMessageIcon} />
          <div className={styles.iconOverlay}></div>
        </div>
        
        <div className={styles.leaveMessageContent}>
          <div className={styles.leaveMessageText}>
            {displayName} has departed
          </div>
        </div>
      </div>
    </div>
  );
}

export default LeaveMessage; 